import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const [clients, setClients] = useState([]);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/admin/clients`, { withCredentials: true }).then(r => setClients(r.data)).catch(() => {});
    axios.get(`${API}/api/admin/questions`, { withCredentials: true }).then(r => setQuestions(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="portal-page-title">Admin Dashboard</h1>
      <p className="portal-page-subtitle">Manage your R6 Advisory clients and sessions</p>

      <div className="portal-grid-2">
        <div className="portal-card">
          <span className="portal-badge">Total Clients</span>
          <p className="portal-stat-value">{clients.length}</p>
          <p>Active advisory clients</p>
        </div>
        <div className="portal-card">
          <span className="portal-badge">Pending Questions</span>
          <p className="portal-stat-value">{questions.filter(q => q.status === 'submitted').length}</p>
          <p>Pre-session questions to review</p>
        </div>
      </div>

      {questions.filter(q => q.status === 'submitted').length > 0 && (
        <div style={{ marginTop: '1.5rem' }}>
          <h3 style={{ color: '#1B2A4E', marginBottom: '1rem' }}>Recent Questions</h3>
          {questions.filter(q => q.status === 'submitted').slice(0, 5).map(q => (
            <div key={q.id} className="portal-card">
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong style={{ color: '#1B2A4E' }}>{q.client_name}</strong>
                <span style={{ fontSize: '0.82rem', color: '#5A6C8A' }}>{new Date(q.created_at).toLocaleDateString()}</span>
              </div>
              <p style={{ marginTop: '0.35rem' }}>{q.questions?.substring(0, 200)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
